import api from "./index";

export default {
    /**
     * Upload
     * @param data
     */
    upload(data) {
        return api.post(`/files/upload`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Validate
     * @param file
     * @param data
     */
    validate(file, data) {
        return api.post(`/files/${file}/validate`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Import
     * @param file
     * @param data
     */
    import(file, data) {
        return api.post(`/files/${file}/import`, data).then((response) => {
            return response.data;
        });
    },

    /**
     * Show
     * @param file
     * @param params
     */
    show(file, params) {
        return api
            .get(`/files/${file}`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get items
     * @param file
     * @param params
     */
    getItems(file, params) {
        return api
            .get(`/files/${file}/items`, {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Get items
     * @param type
     * @param params
     */
    getSampleFile(type, params) {
        return api
            .get(`/files/sample/${type}`, {
                params: params,
                responseType: "arraybuffer",
            })
            .then((response) => {
                return response.data;
            });
    },

    /**
     * Download file
     * @param file
     * @param params
     */
    download(file, params) {
        return api
            .get(`/files/${file}/download`, {
                params: params,
                responseType: "blob",
            })
            .then((response) => {
                return response;
            });
    },

    /**
     * Download file
     * @param uuid
     * @param params
     */
    downloadAdmin(uuid, params) {
        return api
            .get(`/imports/${uuid}/file/download`, {
                params: params,
                responseType: "blob",
            })
            .then((response) => {
                return response;
            });
    },
};
